module.exports = __webpack_public_path__ + "static/media/paleta.7539b421.jpeg";